import React, {useState} from 'react';
import Modal from 'react-modal';
import styles from './CreateModifyTaxInvoicePopUp.module.css';
import Button from '../../../components/common/button/Button';
import {useAlert} from "../../../components/common/error/AlertContext";
import {CreateModifyTaxInvoiceRequest} from "../../../types/admin";
import {createModifyTaxInvoiceAPI} from "../../../services/admin";

interface ModifyTaxInvoicePopUpProps {
    isOpen: boolean;
    onClose: () => void;
    taxInvoiceInfo: {
        taxInvoiceId: number;
        supplyCost: number;
        tax: number;
        purpose: string;
        managerName: string;
        managerNumber: string;
        email: string;
    };
}

//세금계산서 수정 팝업
const ModifyTaxInvoicePopUp: React.FC<ModifyTaxInvoicePopUpProps> = ({
                                                                                             isOpen,
                                                                                             onClose,
                                                                                            taxInvoiceInfo
                                                                                         }) => {
    const [requestData, setRequestData] = useState<CreateModifyTaxInvoiceRequest>({
        taxInvoiceId: taxInvoiceInfo.taxInvoiceId,
        modifyCode: 0,
        supplyCost: taxInvoiceInfo.supplyCost,
        tax: taxInvoiceInfo.tax,
        memo: "",
        purpose: taxInvoiceInfo.purpose,
        managerName: taxInvoiceInfo.managerName,
        managerNumber: taxInvoiceInfo.managerNumber,
        email: taxInvoiceInfo.email
    });
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const {showAlert} = useAlert();

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (isLoading) return;
        //입력 필수값 확인
        if (requestData.email === "") {
            showAlert('담당자 이메일을 입력해주세요.', "error");
            return;
        }
        if (requestData.managerName === "") {
            showAlert('담당자 성명을 입력해주세요.', "error");
            return;
        }
        if (requestData.managerNumber === "") {
            showAlert('담당자 번호를 입력해주세요.', "error");
            return;
        }
        if (requestData.supplyCost === 0) {
            showAlert('공급가액 선택해주세요.', "error");
            return;
        }
        if (requestData.tax === 0) {
            showAlert('세액을 선택해주세요.', "error");
            return;
        }

        setIsLoading(true);
        try {
            await createModifyTaxInvoiceAPI(requestData);
            onClose();
            showAlert('수정 세금계산서가 발행 되었습니다.', "info");
        } catch (error) {
            console.error('failed:', error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <Modal
                isOpen={isOpen}
                onRequestClose={onClose}
                className={styles.modal}
                overlayClassName={styles.overlay}
            >
                <div className={styles.modalContent}>
                    <div className={styles.header}>
                        <h2>수정 세금계산서 발급</h2>
                        <button onClick={onClose} className={styles.closeButton} type="button" aria-label="Close">×
                        </button>
                    </div>
                    <form onSubmit={handleSubmit} className={styles.form}>
                        <div className={styles.formGroup}>
                            <label>수정 사유</label>
                            {/*수정 사유*/}
                            <select
                                value={requestData.modifyCode}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        modifyCode: value
                                    }));
                                }}
                                className={styles.select}
                                disabled={isLoading}
                            >
                                <option value="1">기재사항 착오정정</option>
                                <option value="2">공급가액 변동</option>
                                <option value="3">환입</option>
                                <option value="4">계약의 해제</option>
                                <option value="5">내국신용장 사후개설</option>
                                <option value="6">착오에 의한 이중발급</option>
                            </select>
                        </div>
                        <div className={styles.formGroup}>
                            <label>발행 목적</label>
                            {/*발행 목적*/}
                            <select
                                value={requestData.purpose}
                                onChange={(e) => {
                                    const value = e.target.value
                                    setRequestData(prev => ({
                                        ...prev,
                                        purpose: value
                                    }));
                                }}
                                className={styles.select}
                                disabled={isLoading}
                            >
                                <option value="영수">영수</option>
                                <option value="청구">청구</option>
                                <option value="없음">없음</option>
                            </select>
                        </div>

                        <div className={styles.formGroup}>
                            <label>공급가액</label>
                            <input
                                type="number"
                                value={requestData.supplyCost === 0 ? '' : requestData.supplyCost}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        supplyCost: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>세액</label>
                            <input
                                type="number"
                                value={requestData.tax === 0 ? '' : requestData.tax}
                                onChange={(e) => {
                                    const value = parseInt(e.target.value) || 0;
                                    setRequestData(prev => ({
                                        ...prev,
                                        tax: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>담당자 이메일</label>
                            <input
                                type="text"
                                value={requestData.email}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        email: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>담당자 성명</label>
                            <input
                                type="text"
                                value={requestData.managerName}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        managerName: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>
                        <div className={styles.formGroup}>
                            <label>담당자 전화번호</label>
                            <input
                                type="text"
                                value={requestData.managerNumber}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        managerPhone: value
                                    }));
                                }}
                                min="0"
                                className={styles.input}
                                disabled={isLoading}
                            />
                        </div>

                        <div className={styles.formGroup}>
                            <label>메모</label>
                            <textarea
                                className={styles.textarea}
                                value={requestData.memo}
                                onChange={(e) => {
                                    const value = e.target.value;
                                    setRequestData(prev => ({
                                        ...prev,
                                        memo: value
                                    }));
                                }}
                                placeholder="발행 메모를 입력하세요"
                                required
                            />
                        </div>

                        {/*요청 생성 버튼*/}
                        <Button
                            type="submit"
                            variant="primary"
                            size="large"
                            fullWidth
                            disabled={isLoading}
                        >
                            발행
                        </Button>
                    </form>
                </div>
            </Modal>
        </>
    );
};

export default ModifyTaxInvoicePopUp;